import { HTTPStatusCode } from "@libs/api/types";
import { PatientsQueryKeys } from "@/data/queries/patientsQueries.ts";
import { sendSentryError } from "@/services/sentry.ts";
import { tsRestClient } from "@/services/ts-rest.ts";
import { queryClient } from "@/utils/queryClient.ts";

export const ConsentDocumentsApi = {
  listConsentDocuments: async () => {
    const res = await tsRestClient().consentDocuments.listConsentDocuments();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to get consent document",
      shouldThrowError: true,
    });
  },
  signConsentDocuments: async (
    consentDocumentIds: string[],
    signatureDataUri: string,
  ) => {
    const res = await tsRestClient().consentDocuments.addSignature({
      body: {
        consentDocumentIds,
        signatureDataUri,
      },
    });

    if (res.status === HTTPStatusCode.CREATED) {
      queryClient.setQueryData(PatientsQueryKeys.me(), oldData => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          has_signed_consent_document: true,
        };
      });

      // Invalidate to force re-fetch and update subscribers
      void queryClient.invalidateQueries({
        queryKey: PatientsQueryKeys.me(),
      });

      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to sign consent documents",
      shouldThrowError: true,
    });
  },

  getSignedConsentDocuments: async () => {
    const res =
      await tsRestClient().consentDocuments.getSignedConsentDocuments();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to get signed consent document",
      shouldThrowError: true,
    });
  },
};
